import Model from "./Model";

export default class InventoryEquipment extends Model {
    resource() {
        return "inventory-equipments";
    }
}
